import { render, staticRenderFns } from "./EstructuraComercial.vue?vue&type=template&id=33be799a&"
import script from "./EstructuraComercial.vue?vue&type=script&lang=ts&"
export * from "./EstructuraComercial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('33be799a', component.options)
    } else {
      api.reload('33be799a', component.options)
    }
    module.hot.accept("./EstructuraComercial.vue?vue&type=template&id=33be799a&", function () {
      api.rerender('33be799a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorEstructuraCom/EstructuraComercial.vue"
export default component.exports